import React from "react";
import cx from "classnames";
import {
  useBettingEventStatuses,
  type BettingEventStatus,
} from "hooks/firestore/v2/betting/useBettingEventStatuses";

import * as styles from "./LiveScores.module.scss";

type PeriodScoreProps = {
  className?: string;
  isActive?: boolean;
  homeScore: number;
  awayScore: number;
  name: string;
  key?: string;
};

const PeriodScore = ({
  className,
  homeScore,
  awayScore,
  name,
  isActive = false,
}: PeriodScoreProps) => {
  return (
    <div className={cx(styles.periodScore, { [styles.isActive]: isActive })}>
      <div className={styles.name}>{name}</div>
      <div className={className}>{awayScore}</div>
      <div className={className}>{homeScore}</div>
    </div>
  );
};

const getPeriodName = (
  period: BettingEventStatus["periodScores"][number],
): string => {
  const periodName = (period.name ? period.name.substring(4) : "map")
    .charAt(0)
    .toUpperCase();
  return `${periodName}${period.number}`;
};

export const LiveScores = ({ eventId }: { eventId: string }) => {
  const { bettingEventStatus } = useBettingEventStatuses(eventId);

  return bettingEventStatus ? (
    <div className={styles.scores}>
      {Object.keys(bettingEventStatus.periodScores).map((periodNumber) => {
        const period = bettingEventStatus.periodScores[Number(periodNumber)];
        if (!period) return null;
        return (
          <PeriodScore
            key={`period-${periodNumber}`}
            name={getPeriodName(period)}
            homeScore={period.homeScore}
            awayScore={period.awayScore}
            isActive={period.name === bettingEventStatus.name}
          />
        );
      })}

      <PeriodScore
        className={styles.total}
        homeScore={bettingEventStatus.homeScore}
        awayScore={bettingEventStatus.awayScore}
        name="T"
      />
    </div>
  ) : null;
};
